<div [style.background-color]="backgroundColor" [style.color]="fontColor" [style.font-size]="fontSize" class="pill-container d-flex flex-row align-content-center">
    @if(closeable){
    <div class="close-icon-container" (click)="onCloseClick()">
        <mat-icon class="close-icon">close</mat-icon>
    </div>
    }
    {{ text }}
</div>